import { Button, Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Print, Save } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { useStore } from "app/stores";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo, useEffect, useRef, useState } from "react";
import GlobitsSelectInput from "app/common/form/GlobitsSelectInput";
import UiPrint from "../Component/UiPrint";
import { FORM_PRINT } from "app/common/LocalConst";
import { useReactToPrint } from "react-to-print";
import PrintIcon from "@material-ui/icons/Print";
import PrintForm from "../Print/PrintForm";
import { POSITION_CONSULTANT } from "app/appConfig";
import PrintFormA5 from "../Print/PrintFormA5";
import PrintFormThermalSynthetic from "../Print/PrintFormThermalSynthetic";
import PrintFormA5s from "../Print/PrintFormA5s";
import PrintFormApi from "../Print/PrintFormApi";

const PrintPopup = ({ open, handleClose, dataVoucherFee }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "In phiếu",
  });

  return (
    <PopupForm
      open={open}
      size="xxl"
      height="75vh"
      handleClose={handleClose}
      title={"In phiếu"}
      formik={{
        initialValues: {},
        onSubmit: async (values) => {
          console.log("Data", values);
        },
        enableReinitialize: true,
      }}
      action={(values) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton type="submit" onClick={handlePrint}>
              {!isMobile && <Save className="mr-2 " />}
              In phiếu
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              componentRef={componentRef}
              dataVoucherFee={dataVoucherFee}
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(({ componentRef, dataVoucherFee }) => {
  const { values, setFieldValue } = useFormikContext();
  console.log("dataVoucherFee", dataVoucherFee);
  const staffRevenuesConsultant =
    dataVoucherFee?.items?.length > 0 &&
    dataVoucherFee?.items?.flatMap((el) =>
      el?.staffRevenues?.filter(
        (el) => el?.position?.code === POSITION_CONSULTANT
      )
    );
  console.log("staffRevenues", staffRevenuesConsultant);
  const methodPrint = values.methodPrint;
   console.log("methodPrint", methodPrint); 
  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={3}>
          <GlobitsSelectInput
            label="Loại mẫu phiếu"
            name="methodPrint"
            options={FORM_PRINT}
            onChange={(e) => {
              setFieldValue("methodPrint", e?.target?.value);
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          className="flex-center"
          style={{ border: "1px dashed black", margin: "5px" }}
        >
          {methodPrint === 2 ? (
            <PrintFormThermalSynthetic
              componentRef={componentRef}
              dataVoucherFee={dataVoucherFee}
              staffRevenues={staffRevenuesConsultant}
            />
          ): methodPrint === 3 ? (
            <PrintFormA5s
              componentRef={componentRef}
              dataVoucherFee={dataVoucherFee}
              staffRevenues={staffRevenuesConsultant}
            /> 
          ) : methodPrint === 4 ? (
            <PrintFormThermalSynthetic
              componentRef={componentRef}
              dataVoucherFee={dataVoucherFee}
              staffRevenues={staffRevenuesConsultant}
            /> 
          ) : methodPrint === 5 ? (
            <PrintFormA5s
              componentRef={componentRef}
              dataVoucherFee={dataVoucherFee}
              staffRevenues={staffRevenuesConsultant}
            /> 
          ) : methodPrint === 6 ? (
            <PrintFormA5
              componentRef={componentRef}
              dataVoucherFee={dataVoucherFee}
              staffRevenues={staffRevenuesConsultant}
            />
          ) : (
            <PrintFormApi
              componentRef={componentRef}
              dataVoucherFee={dataVoucherFee}
              staffRevenues={staffRevenuesConsultant}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
});

export default memo(observer(PrintPopup));
